import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

interface Modal2Props {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const Modal2: React.FC<Modal2Props> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="z-[9999999] fixed inset-0  flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-lg max-w-lg w-full p-6 relative mx-4 md:mx-0">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          &times;
        </button>
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal2;
